export default __webpack_public_path__ + "media/metronic/_theme/media/demos/demo9/bg-450-8eb1cd74ed52b5d59735ae10dc294582.jpg";